import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import ProductDetailPage from "../pages/product/page";
import ProductsPage from "../pages/products/page";
import ApplicationsPage from "../pages/applications/page";
import AboutPage from "../pages/about/page";
import SupportPage from "../pages/support/page";
import ContactPage from "../pages/contact/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/product/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/applications",
    element: <ApplicationsPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/support",
    element: <SupportPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
